






































































































import Vue from 'vue'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import { checkIcon } from '@/helper/constants'
import PostMaterialModal from '@/components/common/PostMaterialModal.vue'
import { checkNodeIsCompleted } from '@/helper'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: { PostMaterialModal, BaseIcon },
  name: 'NewYorkPostCategoryPostTree',
  props: {
    categoryTree: {
      type: Array
    },
    completedPosts: {
      type: Set,
      default: new Set()
    },
    postIndexes: {
      type: Object,
      default: null
    },
    activePost: {
      type: Object
    },
    isParentSubCategory: {
      type: Boolean,
      default: false
    },
    available: {
      type: Boolean,
      default: true
    },
    highlightBackground: String,
    highlightColor: String
  },
  data() {
    return {
      checkIcon,
      showModal: false
    }
  },
  computed: {
    postId(): string {
      return this.$route.params.post_id
    },
    templateId(): string {
      return this.$route.query.template_id
    }
  },
  methods: {
    nodeIsPost(type: CategoryTreeNodeType) {
      return type === CategoryTreeNodeType.Post
    },
    nodeIsCompleted(entity: CategoryTreeNode): boolean {
      return checkNodeIsCompleted(this.completedPosts, entity)
    }
  }
})
